
import * as actions from "../actions/loginAction";
import cookie from "react-cookies";
import { environment } from "../../common/sysco-ui-components/config/constant";
import { DASHBOARD, SUPPLIER_PATH } from "../../config/path";
import { DP_ENV } from "../../config/apiConfig";
import Axios from "axios";
import { store } from "../..";
import { LOGIN_MSG, OUTAGE_MSG } from "../actions/actionTypes";
import { Loader } from "../../common/sysco-ui-components/services/commonServices";
import { COOKIE_NAME} from '../../config/string';

export function login(action) {

  try {
    Axios({
      url: `${SUPPLIER_PATH}/get-otds-token`,
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*"
      }
    })
      .then(response => {
        cookie.save("serviceToken", response.data.otdsToken, { path: "/" });
        cookie.save("env", environment(), { path: "/" });
      })
      .catch(err => {
      });

  }
  catch (err) {
    //console.log(err,"lll")
  }
}

/**
 * Load supplier portal message at the startup
 * @param {*} action 
 */
export function getPortalMessage(action) {
  Loader(true)
  try {
    Axios({
      url: `/supplier/get-supplier-message`,
      method: "GET",
      headers: {
        "x-env": DP_ENV
      },
    })
      .then(response => {                        
        const messageResponse = response.data.rows[0].myRows[0];
        store.dispatch({ type: LOGIN_MSG, payload: messageResponse || "" });
        localStorage.setItem("loginMsg", messageResponse['lastModifiedDate']);
        localStorage.setItem("loginMsgDate", messageResponse['loginMessage']);
        Loader(false);
      }).catch(err => {        
        console.log(err);
        Loader(false);
      });

  } catch (error) {
    Loader(false);
    console.log(error);    
  }
}

export function getOutageMessages(action) {
  Loader(true)
  Axios.get("/dish/outage-messages")
    .then(response => {
      store.dispatch({ type: OUTAGE_MSG, payload: response.data });
      sessionStorage.setItem("outageMassages", JSON.stringify(response.data))
      Loader(false);
    }).catch(error => {
      console.error(error);
      Loader(false);
    });
}

/**
 * Get vendornumbers and subvendors on login
 * @param {} action 
 */
export function authLogin(action) {
  let subvendorList = [];
  Axios({
    url: `${SUPPLIER_PATH}/get-vendornumbers-subvendors?vendorNumber=${action.payload.username}`,
    method: "GET"
  })
    .then(res => {
      if (res.data.rows[0].myRows && res.data.rows[0].myRows.length !== 0) {
        subvendorList = res.data.rows && res.data.rows[0].myRows && res.data.rows[0].myRows.length !== 0 && res.data.rows[0].myRows.map(val => val.vendorNumber);
      }
      if (subvendorList.includes("INACTIVEVENDOR")) {
        store.dispatch(actions.inactiveVendor("failed"));
      } else {
        localStorage.setItem("subvendorList", subvendorList);
        window.location.href = DASHBOARD;
        store.dispatch(actions.loginFailed("success"));
      }
    })
    .catch(err => {
      localStorage.setItem("subvendorList", subvendorList);
      window.location.href = DASHBOARD;
    });
}
